import { useState, useEffect } from "react";

const NumberInput = ({ name, value, onChange = null, onBlur = null, className = null, decimals = 0 }) => {
  const formatExternal = (v) => {
    if (v === null || v === undefined || Number.isNaN(v)) return "";
    return decimals >= 0 ? Number(v).toFixed(decimals) : String(v);
  };

  const [prevValue, setValue] = useState(formatExternal(value));
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (!isFocused) setValue(formatExternal(value));
  }, [value, decimals, isFocused]);

  const handleChange = (e) => {
    let raw = e.target.value.replace(",", ".");

    if (raw === "" || raw === "-" || raw === "." || raw === "-.") {
      setValue(raw);
      onChange && onChange({ ...e, target: { ...e.target, name, value: null } });
      return;
    }

    if (!/^(-?)\d*(?:\.\d*)?$/.test(raw)) {
      return;
    }

    const sign = raw.startsWith("-") ? "-" : "";
    let body = sign ? raw.slice(1) : raw;

    if (!body.startsWith("0.") && body.length > 1) {
      body = body.replace(/^0+/, "") || "0";
    }

    if (body.includes(".")) {
      const [intPart, fracPart = ""] = body.split(".");
      if (decimals > 0) {
        body = intPart + "." + fracPart.slice(0, Math.max(0, decimals));
      } else {
        body = intPart;
      }
    }

    const newDisplay = sign + body;
    setValue(newDisplay);

    if (/^-?\d+(\.\d+)?$/.test(newDisplay)) {
      const num = Number(newDisplay);
      onChange && onChange({ ...e, target: { ...e.target, name, value: num } });
    } else {
      onChange && onChange({ ...e, target: { ...e.target, name, value: null } });
    }
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    
    const n = Number(prevValue);
    const formatted = decimals >= 0 ? n.toFixed(decimals) : String(n);
    
    setValue(formatted);
    
    onChange && onChange({ ...e, target: { ...e.target, name, value: Number(formatted) } });
    onBlur && onBlur(Number(formatted))
  };

  const handleFocus = () => setIsFocused(true);

  return (
    <div className={"input-group"}>
      <input
        id={name}
        name={name}
        className={"form-control" + (className ? " " + className : "")}
        type="text"
        inputMode="decimal"
        value={prevValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
      />
      <span className="input-group-text">cm</span>
      <span className="text-danger field-validation-valid" data-valmsg-for={name} data-valmsg-replace="true"></span>
    </div>
  );
};

export default NumberInput;
